import React from 'react'

function HospitalUserManagement() {
  return (
    <div>"User & Role Management (RBAC, permissions like pharmacy.create_grn)</div>
  )
}

export default HospitalUserManagement